import useApi from "../useApi";
import { TranslationInterface } from "../../interfaces/TranslationInterface";

interface UseGetTranslationInterface {
  getById: (id: string) => Promise<TranslationInterface | null>;
}

const useGetTranslation = (): UseGetTranslationInterface => {
  const { get } = useApi();

  const getById = async (id: string): Promise<TranslationInterface | null> => {
    const { data, status } = await get(`/translation/${id}`);

    if (status !== 200) {
      // todo
      throw new Error("Unknown");
    }

    return data;
  };

  return { getById };
};

export default useGetTranslation;
